// Dedicated capability HTTP client for the anonymous public catalog/booking
// widget. Deliberately independent from `@infrastructure/api/axios` and
// `services/admin/axios.js` — both attach a Firebase `Authorization` header,
// and the backend rejects requests presenting both authority methods. This
// client never carries credentials and only ever sends `X-Access-Grant`.
export class CapabilityRequestError extends Error {
    status;
    responseBody;
    retryAfter;
    constructor(status, responseBody, retryAfter = null) {
        super(`Capability request failed with ${status}`);
        this.status = status;
        this.responseBody = responseBody;
        this.retryAfter = retryAfter;
        this.name = "CapabilityRequestError";
    }
}
export async function capabilityRequest(input) {
    const response = await fetch(`${input.apiBaseUrl}${input.path}`, {
        method: input.method ?? "GET",
        credentials: "omit",
        headers: {
            Accept: "application/json",
            ...(input.body === undefined ? {} : { "Content-Type": "application/json" }),
            "X-Access-Grant": input.accessGrant,
        },
        body: input.body === undefined ? undefined : JSON.stringify(input.body),
    });
    const responseBody = await response.json();
    if (!response.ok) {
        throw new CapabilityRequestError(response.status, responseBody, response.headers.get("Retry-After"));
    }
    return responseBody.data;
}
